<template>
  <button-base :borderRadius="'sm1'" :type="'solid'" :class="componentClasses" @click="clicked()">
    <div class="gc-button-link-forward__left-section">
      <slot class="gc-button-link-forward__left-section-icon"></slot>
      <div class="gc-button-link-forward__text-section">
        <text-content class="text-section__title" :class="textClass" :line-height="'multi'" :size="'sm3'" :weight="'extra-bold'"> {{ text }}</text-content>
        <text-content class="text-section__sub-title" :class="subTextClass" :line-height="'multi'" :size="'sm1'" v-if="hasSubText"> {{ subText }}</text-content>
      </div>
    </div>
    <div class="gc-button-link-forward__right-section">
      <icon-forward></icon-forward>
    </div>
  </button-base>
</template>

<script>

import TextContent from '../../root/TextContent'
import ButtonBase from '../../root/ButtonBase'
import IconForward from '../../root/icons/IconForward'

export default {
  name: 'ButtonLinkForward',
  components: {
    ButtonBase,
    IconForward,
    TextContent
  },
  props: {
    /**
     * The main text of the button
     */
    text: {
      default: ''
    },
    /**
     * The sub text of the button
     */
    subText: {
      default: ''
    },
    /**
     * The disabled state of the button
     */
    disabled: {
      default: false
    }
  },
  computed: {
    hasSubText: function () {
      return this.subText.replace(/\s/g, '') !== ''
    },
    hasIcon () {
      return !!this.$slots.default
    },
    textClass: function () {
      return {
        'gc-button-link-forward__text': true,
        'gc-button-link-forward__text--with-sub-text': this.hasSubText
      }
    },
    subTextClass: function () {
      return {
        'gc-button-link-forward__sub-text': this.hasSubText
      }
    },
    componentClasses: function () {
      return {
        'gc-button-link-forward': true,
        'gc-button-link-forward--with-sub-text': this.hasSubText,
        'gc-button-link-forward--disabled': this.disabled
      }
    }
  },
  methods: {
    /**
     * function to emit the click event
     */
    clicked () {
      if (!this.disabled) {
        this.$emit('click')
      }
    }
  }
}
</script>

<style scoped></style>
